// extracted by mini-css-extract-plugin
export default {"fr-password-info":"styles_fr-password-info__H0mxS","fr-password-success":"styles_fr-password-success__Qe+EX","fr-password-error":"styles_fr-password-error__u+LIb"};